<template>
  <div class="cert-list">
    <h6 class="cert-list__title">My Certifications</h6>
    <div class="cert-list__wrapper">
      <CertificationsListItem
        v-for="certification in certifications"
        :key="certification.id"
        :certification="certification"
        :attempt="certAttempt(certification.attempt_id)"
        @close-renewal-modal="pollCertifications"
      />
      <router-link
        :to="{ name: 'certifications' }"
        :class="[
          'cert-list__get',
          certifications.length === 0 && 'cert-list__get--no-certs',
        ]"
      >
        <div class="cert-list__icon-wrapper">
          <PlusSymbolIcon class="cert-list__plus-icon" />
        </div>
        <p class="cert-list__get-certs">GET Certifications</p>
      </router-link>
    </div>
  </div>
</template>

<script>
import CertificationsListItem from '@/components/user-dashboard/certifications/CertificationsListItem.vue'
import PlusSymbolIcon from '@/assets/icons/plus_symbol_icon.svg'
import { mapActions, mapGetters } from 'vuex'
import { allFinishedAttempts } from '@/helpers'

export default {
  name: 'CertificationsList',
  components: {
    CertificationsListItem,
    PlusSymbolIcon: { ...PlusSymbolIcon, name: 'PlusSymbolIcon' },
  },
  props: {
    certifications: {
      type: Array,
      required: true,
    },
  },
  data: () => {
    return {
      finishedAttempts: [],
      certificationUpdateIntervalId: null,
      certificationUpdateIntervalExceeded: false,
    }
  },
  computed: {
    ...mapGetters({
      allVouchers: 'certifications/usersVouchers',
      renewalModalStatus: 'cpeProgram/cpeRenewModalStatus',
    }),
  },
  created() {
    this.finishedAttempts = allFinishedAttempts(this.allVouchers)
  },
  methods: {
    ...mapActions({
      getUsersCertifications: 'certifications/getUsersCertifications',
      setNotification: 'app/setNotification',
    }),
    certAttempt(attempt_id) {
      return this.finishedAttempts.find(a => a.id === attempt_id)
    },
    pollCertifications(certificationId, setIsRenewalLoading) {
      if (
        this.renewalModalStatus.isRenewal &&
        this.renewalModalStatus.step === 'success' &&
        !this.certificationUpdateIntervalExceeded
      ) {
        let attempts = 0
        const intervalId = setInterval(async () => {
          await this.getUsersCertifications()
          attempts++
          const certification = this.certifications.find(
            cert => cert.id === certificationId
          )
          if (attempts >= 5) {
            setIsRenewalLoading(false)
            clearInterval(intervalId)
            this.setNotification(
              `Your purchase is processing. Once complete, we'll email your receipt, and your certification will be renewed.`
            )
            this.certificationUpdateIntervalExceeded = true
          }
          if (certification && certification.expiration_status === 'early') {
            setIsRenewalLoading(false)
            clearInterval(intervalId)
          }
        }, 5000)
        this.certificationUpdateIntervalId = intervalId
      } else {
        setIsRenewalLoading(false)
        if (this.certificationUpdateIntervalId) {
          clearInterval(this.certificationUpdateIntervalId)
          this.certificationUpdateIntervalId = null
          this.certificationUpdateIntervalExceeded = false
        }
      }
    },
  },
}
</script>

<style lang="scss">
.cert-list {
  &__wrapper {
    @include tablet {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 20px;
    }
  }
  &__title {
    font-size: rem(24);
    line-height: 32px;
    color: var(--white);
    padding: 0;
    margin: 0 0 30px 0;
    width: 100%;
  }
  &__get {
    border-radius: 10px;
    width: 100%;
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
    border: 1px dashed var(--perfect-gray);
    &:hover {
      opacity: 0.8;
    }
    &-certs {
      text-transform: uppercase;
      font-size: rem(12);
      font-weight: bold;
      line-height: 15px;
      color: var(--perfect-gray);
    }
    &--no-certs {
      max-width: 320px;
      height: 470px;
    }
  }
}
</style>
